import { ApiRequest } from './helper';
import { GetToken, SetToken } from './token';

export const initAuthToken = (token) => {
  const store_token = GetToken();

  if (store_token && token == null) {
    return JSON.parse(store_token);
  } else {
    SetToken(
      JSON.stringify({
        token: token,
      })
    );
    return {
      token: token,
    };
  }
};

export async function Auth(user) {
  try {
    const stoken = GetToken();

    if (stoken && user.token == null) {
      const user_data = JSON.parse(stoken);
      return {
        ...user_data,
      };
    } else {
      const response = await ApiRequest(
        'GET',
        null,
        `${process.env.REACT_APP_API_URL}/api/Authorization/GetTokenUserId`,
        null,
        user.token
      );

      if (response.ok) {
        const data = await response.text();
        if (data !== null) {
          const user_data = {
            ...user,
            id: data,
          };

          SetToken(JSON.stringify(user_data));

          return {
            ...user_data,
          };
        }
      }
    }
  } catch (error) {}
}
